<template>
    <div class="custom-drawer__footer p-4 flex justify-end">
        <el-button  @click="cancel">Cancel</el-button>
        <el-button type="primary" @click="handleButton" :loading="this.buttonLoading" :disabled="handleDisabled()">{{labelButton}}</el-button>
    </div>
</template>
<script>
export default {
    name: "Drawer",
    props: ['open', 'labelButton', 'buttonLoading', 'disabled'],
    data(){
        return {
            visible: false,
        }
    },
    methods:{
        cancel(){
            this.$emit('cancel')
        },
        handleButton(){
            this.$emit('cbk-button')
        },
        handleDisabled() {
            if (this.disabled === undefined) return false
            return this.disabled
        }
    }
}
</script>
<style>
</style>